module.exports = __webpack_public_path__ + "static/media/img_2.754d369e.png";